import { Field } from '@common/constants';
import { StorageKeysModel } from 'common';

export const constants = {
  roles: { SchemeAdmin: 'SchemeAdmin', User: 'User' },
  processingStates: {
    Unavailable: 'Unavailable',
    Queued: 'Queued',
    Processing: 'Processing',
    Completed: 'Completed',
    Failed: 'Failed'
  },
  endpointTags: {
    all: ['token', 'capabilities', 'delegation', 'authorize', 'token-authorization-code', 'userinfo'],
    token: 'token',
    token_authorization_code: 'token-authorization-code',
    capabilities: 'capabilities',
    delegation: 'delegation',
    authorize: 'authorize',
    userinfo: 'userinfo'
  },
  profileStatus: {
    active: new Field('Active', 'Active'),
    disabled: new Field('Disabled', 'Disabled')
  }
};
export const storageKeys: StorageKeysModel = {
  auth: 'iSHARE.CTT.auth',
  profile: 'iSHARE.CTT.profile',
  logging: 'iSHARE.CTT.logging',
  authExpiration: 'iSHARE.CTT.authExpiration',
  settings: 'iSHARE.CTT.settings'
};
